import { isIndexedDbConnectionError, isStaleChunkError } from "./chunkLoadRecovery";

export function isTransientNetworkError(error) {
  const message = String(error?.message || error || "");
  return (
    /failed to fetch/i.test(message) ||
    /load failed/i.test(message) ||
    /networkerror/i.test(message) ||
    /network request failed/i.test(message) ||
    /auth\/network-request-failed/i.test(message)
  );
}

export function isExpectedCompanyValidationError(error) {
  if (typeof error?.code === "string" && error.code.startsWith("api/company-")) {
    return true;
  }

  const message = String(error?.message || "");
  return (
    /Preencha todos os dados cadastrais/i.test(message) ||
    /Complete all required registration fields/i.test(message) ||
    /Completa todos los datos de registro/i.test(message)
  );
}

export function shouldIgnoreSentryEvent(event) {
  const message =
    event.exception?.values?.[0]?.value ||
    event.exception?.values?.[0]?.type ||
    event.message ||
    "";

  if (isStaleChunkError(message)) return true;
  if (isTransientNetworkError(message)) return true;
  if (isIndexedDbConnectionError(message)) return true;
  if (/aborterror|signal is aborted/i.test(message)) return true;
  if (/devin security audit/i.test(message)) return true;
  if (isExpectedCompanyValidationError({ message })) return true;

  return false;
}
